import * as Api from '@ViewModels';
import { THEME } from '../../../components-v2/Theme/theme';

export const PRIORITIES: Api.ActionItemPriority[] = ['High', 'Medium', 'Low', 'None'];

const PRIORITY_RANK: Record<Api.ActionItemPriority, number> = { High: 3, Medium: 2, Low: 1, None: 0 };

export const PRIORITY_LABELS: Record<Api.ActionItemPriority, string> = {
	High: 'High priority',
	Medium: 'Medium priority',
	Low: 'Low priority',
	None: 'No priority',
};

export function getPriority(item: Pick<Api.IActionItem, 'priority'>): Api.ActionItemPriority {
	return item.priority ?? 'None';
}

export function priorityRank(priority: Api.ActionItemPriority | undefined): number {
	return PRIORITY_RANK[priority ?? 'None'];
}

export function priorityColor(priority: Api.ActionItemPriority | undefined): string {
	switch (priority) {
		case 'High':
			return THEME.colors.danger.main;
		case 'Medium':
			return THEME.colors.warning.main;
		case 'Low':
			return THEME.colors.primary.main;
		default:
			return THEME.colors.icon.gray;
	}
}
